import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.css']
})
export class StepsComponent {
  @Input() step: number = 1;
}